module.exports = __webpack_public_path__ + "img/Button-kosik-2021-09.d30430ad.png";